import { useEffect } from 'react'
import { LandingNav } from '../WelcomePage/LandingNav'
import { DocsSidebar } from './DocsSidebar'
import { DocsContent } from './DocsContent'
import styles from './DocsPage.module.css'

export function DocsPage() {
  useEffect(() => {
    document.title = 'Docs - Fantasy Console 0'
    document.body.style.overflow = 'auto'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <div className={styles.page}>
      <LandingNav minimal />
      <div className={styles.layout}>
        <div className={styles.sidebar}>
          <DocsSidebar />
        </div>
        <main className={styles.content}>
          <DocsContent />
        </main>
      </div>
    </div>
  )
}
